/**
 * 股票相关的 mixin
 */
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

export default {
  computed: {
    // 期权
    isOPT() {
      return this.stock.secType === SEC_TYPE.OPT
    },
    // 正股
    isSTK() {
      return this.stock.secType === SEC_TYPE.STK
    },
    // 窝轮
    isWAR() {
      return [SEC_TYPE.WAR, SEC_TYPE.IOPT].includes(this.stock.secType)
    },
    // 期货
    isFUT() {
      return this.stock.secType === SEC_TYPE.FUT
    },
    // 港股
    isHK() {
      return this.stock.market === MARKET_TYPE.HK
    },
    // 美股
    isUS() {
      return this.stock.market === MARKET_TYPE.US
    },
    // A股市场
    isCN() {
      return [MARKET_TYPE.SH, MARKET_TYPE.SZ, MARKET_TYPE.CN].includes(
        this.stock.market
      )
    },
    // 指数
    isIndex() {
      return this.stock.isIndex || this.stock.symbolType === 'index'
    },
    // OTC
    isOTC() {
      return !!this.stock.otc
    },
    // ETF
    isETF() {
      return !!this.stock.etf
    },
    // 不是ETF
    isNotETFStock() {
      return !this.stock.etf || this.stock.etf === 0
    }
  }
}
